var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClient5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 685,
    height: 102,
    viewBox: "0 0 685 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.5 63C110.5 40.2 126.7 24 149.5 24C172.3 24 188.5 40.2 188.5 63C188.5 85.9 172.3 102 149.5 102C126.7 102 110.5 85.9 110.5 63ZM169 63C169 50.2 161.4 42 149.5 42C137.7 42 130 50.2 130 63C130 75.7 137.6 84 149.5 84C161.3 84 169 75.7 169 63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 25.5H220V30C224.3 26.2 229.9 24 236.2 24C244.3 24 251.3 26.8 256.6 31.8C262.3 26.8 270.1 24 278.9 24C297.6 24 311.4 36.6 311.4 54.7V100.4H292V54.7C292 47.2 286.9 41.9 279 41.9C271.1 41.9 265.8 47.1 265.8 54.7V100.4H246.3V54.7C246.3 47.2 241.2 41.9 233.3 41.9C225.4 41.9 220 47.2 220 54.7V100.4H200.5V25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5 63C323.5 40.2 339.7 24 362.5 24C370 24 376.6 26.2 382 30.3V25.5H401.5V100.5H382V95.7C376.6 99.7 370 102 362.5 102C339.7 102 323.5 85.9 323.5 63ZM382 63C382 50.2 374.4 42 362.5 42C350.6 42 343 50.2 343 63C343 75.7 350.7 84 362.5 84C374.3 84 382 75.7 382 63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.5 43.5H442V72.6C442 79.2 445.3 82.5 452 82.5H464.5V100.5H450.5C431.8 100.5 422.5 91.2 422.5 72.6V43.5H415V25.5H422.5V0H442V25.5H464.5V43.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 25.5H497.5V35.3L520 25.5V45.7L497.5 54.7V100.4H478V25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.5 63C527.5 40.2 543.7 24 566.5 24C589.3 24 605.5 40.2 605.5 63C605.5 85.9 589.3 102 566.5 102C543.7 102 527.5 85.9 527.5 63ZM586 63C586 50.2 578.4 42 566.5 42C554.6 42 547 50.2 547 63C547 75.7 554.6 84 566.5 84C578.4 84 586 75.7 586 63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5 25.5H637V30.3C641.5 26.3 647.3 24 653.9 24C671.4 24 684.2 37 684.2 55.5V100.5H664.7V55.5C664.7 47.5 658.9 42 650.9 42C642.7 42 637 47.5 637 55.5V100.5H617.5V25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H0V101.5H20.5V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.323395 1.0717L0.323395 21.5717L77.7234 21.5717V1.0717L0.323395 1.0717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.275604 81.0195L0.275604 101.52H77.6756V81.0195H0.275604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4413 80.9961H97.9413L97.9413 21.5961H77.4413V80.9961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 684.2,
    height: 102,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient5);
export default __webpack_public_path__ + "static/media/client_5.c05947c8805dfb386b3ea56d19930e73.svg";
export { ForwardRef as ReactComponent };